<template>
  <div class="d-none">


  </div>
</template>

<script>
export default {
  mounted() {


    const customerData = this.getCustomerData(); // Function to retrieve customer data


    if (App?.language === 'de') {
      this.loadHelpScout('011917a0-3d7a-439d-a6fd-3da110840c38', customerData);
    }
    else{
      this.loadHelpScout('b1a981cd-5ff7-465e-8701-6fadaa944b8e', customerData);


      /*const script = document.createElement("script");
      script.type = "text/javascript";


      script.innerHTML = `
      var FreeScoutW = {
        s: {
          "color": "#359bee",
          "position": "br",
          "locale": "en",
          "require": ["name", "email"],
          "id": 3983599863
        }
      };
      (function(d, e, s) {
        if (d.getElementById("freescout-w")) return;
        var a = d.createElement(e);
        var m = d.getElementsByTagName(e)[0];
        a.async = 1;
        a.id = "freescout-w";
        a.src = s;
        m.parentNode.insertBefore(a, m);
      })(document, "script", "https://desk.tradeo.de/modules/chat/js/widget.js?v=8434");

    `;
      document.body.appendChild(script);*/
    }

  },
  methods: {
    loadHelpScout(beaconId, customerData = null) {
      function loadScript() {
        var e = document.getElementsByTagName("script")[0],
            n = document.createElement("script");
        n.type = "text/javascript";
        n.async = true;
        n.defer = true; // Ensure defer is set
        n.src = "https://beacon-v2.helpscout.net";
        e.parentNode.insertBefore(n, e);
      }

      if (window.Beacon = function (t, n, a) {
        window.Beacon.readyQueue.push({method: t, options: n, data: a});
      }, window.Beacon.readyQueue = [], document.readyState === "complete") {
        loadScript();
      } else {
        window.addEventListener("load", loadScript, false);
      }

      window.Beacon('init', beaconId);

      /*window.Beacon('config', {
        display: {
          text: true // Set text to false to hide the "Support" label
        }
      });*/

      if (customerData) {
        window.Beacon('identify', customerData);
      }
    },
    getCustomerData() {

      if (this.isCustomerLoggedIn()) {
        let userData = ceresStore?.state?.user?.userData;

        return {
          name: userData.fullName,
          email: userData.email,
          serverConfigId:'test123 hardcoded'
          // attributes: {
          //   test: "123",
          // }
        };
      }
      return null;
    },
    isCustomerLoggedIn() {
      return  (ceresStore?.state?.user?.userData?.id > 0);
    }

  },
  computed:{
    lang()
    {
      return App?.language ?? 'de';
    },
  }
};
</script>
